import { BaseCssVarValue } from '@/views/game/components/gameCardSuit/components/baseCssVarInject'

export abstract class _RectangleStarBase extends BaseCssVarValue {
  abstract cssType: 'default' | 'small'
  /** 收藏图标方型背景宽度 */
  ['--favorited-icon-width']?: string;
  /** 收藏图标方型背景高度 */
  ['--favorited-icon-height']?: string;
  /** 收藏图标字体大小 */
  ['--favorited-icon-font-size']?: string
}
